
export const GET_TAG = "GET_TAG";
export const GET_TAG_FAILURE = "GET_TAG_FAILURE";
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS";